import { Outlet } from "react-router-dom";

import { AppSidebar } from "components/AppSidebar";
import { SidebarMobileTriggerBar } from "components/sidebar/SidebarMobileTrigger";
import { SIDEBAR_STYLE } from "components/sidebar/sidebarShell";
import { SidebarProvider, SidebarInset } from "components/ui/sidebar";
import RequireAuth from "routes/higher-order/RequireAuthHOC";
import useGlobalSidebarStore from "stores/useGlobalSidebarStore";

export function ProtectedLayout({ hideNav = false }) {
  const open = useGlobalSidebarStore(state => state.open);
  const setOpen = useGlobalSidebarStore(state => state.setOpen);

  return (
    <RequireAuth>
      <SidebarProvider open={open} onOpenChange={setOpen} style={SIDEBAR_STYLE}>
        {!hideNav && <AppSidebar />}
        <SidebarInset className="tw:flex-1 tw:flex tw:flex-col tw:overflow-y-auto tw:min-h-0 tw:h-screen">
          {!hideNav && <SidebarMobileTriggerBar label="Main Menu" />}
          <Outlet />
        </SidebarInset>
      </SidebarProvider>
    </RequireAuth>
  );
}
